<template >
    <div class="body d-flex py-lg-3 py-md-2 mb-5" v-if="hasCRM">
        <div class="container-xxl">
            <div class="row clearfix">
                <div class="col-md-12">
                    <div class="card border-0 mb-2 no-bg">
                        <div class="card-header py-1 px-0 d-sm-flex align-items-center justify-content-between main-button-area">
                            <div class="search-area">
                                        <input id="main-search-input" type="search" class="form-control"
                                            placeholder="Search Employee" aria-label="search"
                                            aria-describedby="addon-wrapping" />
                                    </div>
                           <!--  <ul class="nav nav-tabs tab-body-header rounded mt-sm-0 mt-3 ms-0 prtab-set w-sm-100" role="tablist">
                                <li class="nav-item col">
                                    <a :class="{ 'nav-link text-center active': filters.active == 1, 'nav-link text-center': filters.active == 0 }"
                                        @click.prevent="() => updateFilters({ active: 1, page: 1 })" href="#" role="tab">Active</a>
                                </li>
                                <li class="nav-item col">
                                    <a :class="{ 'nav-link text-center active': filters.active == 0, 'nav-link text-center': filters.active == 1 }"
                                        @click.prevent="() => updateFilters({ active: 0, page: 1 })" href="#" role="tab">Inactive</a>
                                </li>
                            </ul> -->

                            <div class="d-flex mt-sm-0 mt-3 justify-content-between">
                                <button type="button" class="ms-0 ms-sm-3 btn btn-dark newuserbtn" style="color:var(--secondary-color); font-weight:bold" @click.prevent="createUser" v-if="canCreateUser || superUser">
                                    <i class="icofont-plus me-2 fs-6"></i>New employee
                                </button>
                                <div class="dropdown" @click="toggleDropdown" @blur="closeDropdown" tabindex="0" v-if="canArchive || superUser">
                                    <button class="ms-0 ms-sm-3 btn btn-primary dropdown-menu-toggler"  style="color:var(--secondary-color); font-weight:bold" type="button">
                                        <i class="wx-ic wx-ic-trash" title="Archive"></i>
                                    </button>
                                    <ul class="dropdown-menu border-0 shadow p-3" :class="{'show': isDropdownOpen}" :style="dropdownStyle">
                                        <li>
                                            <a class="dropdown-item py-2 rounded archiveSelected" href="#" @click.prevent="archiveUsers">
                                                Αρχειοθέτηση επιλεγμένων
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div class="ms-3 d-flex align-items-center">
                                        <i class="wx-ic wx-ic-list" v-if="isGridView" title="List" @click="isGridView = false"></i>
                                        <div v-if="!isGridView" class="wx-ic-on">
                                            <i class="wx-ic wx-ic-list" title="List" @click="isGridView = false"></i>
                                        </div>
                                        <i class="wx-ic wx-ic-grid" v-if="!isGridView" title="Grid" @click="isGridView = true"></i>
                                        <div v-if="isGridView" class="wx-ic-on">
                                            <i class="wx-ic wx-ic-grid" title="Grid" @click="isGridView = true"></i>
                                        </div>
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="!isGridView" class="card-body table-responsive">
                                <table id="projectTable" class="table table-hover align-middle mb-0 mis_table"
                                    style="width:100%">
                                    <thead>
                                        <tr>
                                            <th style="width:3%;" v-if="canArchive || superUser"></th>

                                            
                                            <th style="width:20%;">
                                                <div>Employee<i class="fa fa-sort sorting-icon"
                                                        @click.prevent="sortBy('name')"></i></div>
                                            </th>
                                            <th style="width:20%;">
                                                <div>Email<i class="fa fa-sort sorting-icon"
                                                        @click.prevent="sortBy('email')"></i></div>
                                            </th>
                                            <th style="width:20%;">
                                                <div>Phone<i class="fa fa-sort sorting-icon"
                                                        @click.prevent="sortBy('tel')"></i></div>
                                            </th>
                                            <th style="width:15%;" v-if="hasProjectManagement">
                                                <div>Projects Assigned</div>
                                            </th>
                                            <th class="no-after"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(user, index) in data" :key="user.info.id" :class="{ 'selected': selectedUserIds.includes(user.info.id) }">

                                            <td  v-if="canArchive || superUser" >
                            <input 
type="checkbox"
:checked="selectedUserIds.includes(user.info.id)"
@change="toggleUsersSelection(user.info.id, $event)"
@click.stop
/>                                        </td>
                                           
                                            <td >
                                                {{ user.info.name }} {{ user.info.surname }}
                                            </td>

                                            

                                            <td >
                                                {{ user.info.email }}
                                            </td>  
                                            <td >
                                                {{ user.info.tel }}
                                            </td>  
                                            <td v-if="hasProjectManagement">
                                                {{user.projectCount?.total || 0 }}
                                            </td>                                          
                                            <td>
                                                 <div class="button-group">
                                                    
                                                    <div class="icon-wrapper">
                                                        <button class="btn btn-dark"
                                                        @click="editUser(user.info.id)" v-if="superUser || canEditAllUsers || (canEditUser && user.info.id === getUser)">
                                                            <i class="wx-ic wx-ic-edit" title="Edit"></i>
                                                        </button>
                                                    </div>
                                                    
                                                </div>  
                                            </td>

                                        </tr>
                                        <tr class="col" v-if="!data || !data.length">
                                            <td colspan="100">No data</td>

                                        </tr>
                                    </tbody>
                                </table>

                            </div>
            <div v-if="isGridView"  class="row g-3 row-cols-1 row-cols-sm-1 row-cols-md-1 row-cols-lg-2 row-cols-xl-4 row-cols-xxl-4 row-deck py-1 pb-4" style="position: relative; z-index: 0">
                <div class="col-6" v-for="(user, index) in data" :key="user.info.id">
                    <div class="card teacher-card" :class="{ 'shadow': selectedUserIds.includes(user.info.id) }">
                        <div class="card-body position-relative" style="border-radius: 15px; background: #eae8e8 !important; color: black;">
                            <div class="d-flex align-items-center gridmob">
                                <div class="checkbox-wrapper">
                                    <input type="checkbox" @change="toggleUserSelection(user.info.id, $event)">
                                </div>
                                <div class="profile-av text-center ms-0 ms-xl-3">
                                    <img v-if="user.info.avatar_file_name"  :src="`/storage/avatars/${user.info.avatar_file_name}`" alt="" class="avatar xl rounded-circle img-thumbnail shadow-sm">
                                    <img v-else src="../assets/images/lg/avatar3.jpg" alt="" class="avatar xl rounded-circle img-thumbnail shadow-sm">

                                </div>
                                <div class="ms-0 ms-xl-3 user-info">
                                    <h5 class="mb-0 mt-2 fw-bold d-block fs-6">{{ user.info.username }}</h5>
                                </div>
                                <button type="button" style="padding: 4px 6px; border-color: black" class="btn btn-light ms-auto mt-1 w-sm-100 show-edit-user-modal" @click="editUser(user.info.id)" v-if="superUser || canEditAllUsers || (canEditUser && user.info.id === getUser)">
                                    <i class="icofont-pencil fs-5"></i>
                                </button>
                            </div>
                            <div class="userInfoText mt-3">
                                <div class="d-flex align-items-center mb-2">
                                    <i class="icofont-email fs-4 text-secondary"></i>
                                    <span class="ms-2">{{ user.info.email || 0 }}</span>
                                </div>
                                <div class="d-flex align-items-center">
                                    <div class="rounded-circle bg-secondary text-white d-flex align-items-center justify-content-center" style="width: 24px; height: 24px;" v-if="hasProjectManagement">
                                        {{ user.projectCount?.total || 0 }}
                                    </div>
                                    <span class="ms-2" v-if="hasProjectManagement">Projects Assigned</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="col" v-if="!data || !data.length">
                <p>Δεν βρεθηκαν αποτελέσματα........</p>
            </div> -->
        </div>
        <nav aria-label="Page navigation">
            <ul class="pagination mt-4" v-if="paginationLinks && paginationLinks.length > 0">
                <li class="page-item" v-for="(paginationLink, index) in paginationLinks" :key="index" :class="{ active: paginationLink.active }">
                    <router-link :to="{ path: 'employees', query: { ...filters, page: getPageFromUrl(paginationLink.url) } }" v-if="paginationLink.url">
                        <span class="page-link" v-html="paginationLink.label"></span>
                    </router-link>
                    <span class="page-link" v-else v-html="paginationLink.label"></span>
                </li>
            </ul>
        </nav>
    </div>

        <!-- Modal for creating a new user -->
        <div class="modal fade" id="create-employee-form" tabindex="-1" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-md modal-dialog-scrollable">
                        <div class="modal-content">
                            <div class="modal-header">
                        <h5 class="modal-title fw-bold" id="createprojectlLabel">Employee Data</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <input name="id" id="id" type="hidden" v-model="userData.id" />
                        <div class="deadline-form">
                            <div class="row g-3 mb-3">
                                <div class="col-sm-4">
                                <label for="userEmail" class="form-label">Email</label>
                            <input type="email" class="form-control" id="userEmail" v-model="userData.email" required
                                placeholder="">
                            </div>
                             
                         <div class="col mt-5" v-if="!userData.id">
                            <label for="sendEmail" class="form-label me-2">Αποστολή Email για συμπλήρωση φόρμας</label>
                            <input input class="form-check-input mt-1" type="checkbox" id="sendEmail" v-model="userData.sendEmail"
                                placeholder="">
                        </div>
                    </div> </div>
                        <div class="deadline-form" v-if="!userData.sendEmail">
                            <div class="row g-3 mb-3">
                               
                                
                            </div>
                            <div class="row g-3 mb-3">
                                
                                
                            </div>
                          

                            <div class="row g-3 mb-3">
                               
                                <div class="col-sm-4">
                                    <label for="userName" class="form-label">Name</label>
                                    <input type="text" class="form-control" id="userName" v-model="userData.name"
                                        placeholder="">
                                </div>
                                <div class="col-sm-4">
                                    <label for="userSurname" class="form-label">Surname</label>
                                    <input type="text" class="form-control" id="userSurname" v-model="userData.surname"
                                        placeholder="">
                                </div>
                                <div class="col-sm-4">
                                    <label for="userHireDate" class="form-label">Hiredate</label>
                                    <input type="date" class="form-control" id="userHireDate"
                                        v-model="userData.hireDate" placeholder="">
                                </div>
                                <div class="col">
                                    <label for="userFatherFullName" class="form-label">FatherName</label>
                                    <input type="text" class="form-control" id="userFatherFullName"
                                        v-model="userData.fatherFullName" placeholder="Ονοματεπώνυμο Πατέρα">
                                </div>
                                <div class="col">
                                    <label for="userMotherFullName" class="form-label">MotherName</label>
                                    <input type="text" class="form-control" id="userMotherFullName"
                                        v-model="userData.motherFullName" placeholder="Ονοματεπώνυμο Μητέρας">
                                </div>
                                <div class="col">
                                    <label for="userSpouseFullName" class="form-label">Spouse Fullname</label>
                                    <input type="text" class="form-control" id="userSpouseFullName"
                                        v-model="userData.spouseFullName" placeholder="Ονοματεπώνυμο συζύγου">
                                </div>
                            </div>
                            <div class="row g-3 mb-3">
                                <div class="col">
                                    <label class="form-label">Identity Type</label>
                                    <select class="form-select" id="userIdentityType" v-model="userData.identityType"
                                        aria-label="ΕΙΔΟΣ ΤΑΥΤΟΤΗΤΑΣ">
                                        <option selected="" value="Αστυνομική Ταυτότητα">ID</option>
                                        <option value="">Passport</option>
                                    </select>
                                </div>
                                <div class="col">
                                    <label for="userIdentityNum" class="form-label">Identity Code</label>
                                    <input type="text" class="form-control" id="userIdentityNum"
                                        v-model="userData.identityNum" placeholder="">
                                </div>
                            </div>
                            <div class="row g-3 mb-3">
                                <div class="col-sm-6">
                                    <label for="userIdentityCreationDate" class="form-label">Ημερ.Έκδοσης
                                        Ταυτότητας</label>
                                    <input type="date" class="form-control" id="userIdentityCreationDate"
                                        v-model="userData.identityCreationDate">
                                </div>
                                <div class="col">
                                    <label for="userIdentityCreationDepartment" class="form-label">Έκδουσα Αρχή</label>
                                    <input type="text" class="form-control" id="userIdentityCreationDepartment"
                                        v-model="userData.identityCreationDepartment" placeholder="Έκδουσα Αρχή">
                                </div>
                                <div class="col-sm-6">
                                    <label for="userAfm" class="form-label">AFM</label>
                                    <input type="number" class="form-control" id="userAfm" v-model="userData.afm"
                                        placeholder="ΑΦΜ">
                                </div>
                                <div class="col-sm-6">
                                    <label for="userDoy" class="form-label">ΔΟΥ</label>
                                    <input type="text" class="form-control" id="userDoy" v-model="userData.doy"
                                        placeholder="ΔΟΥ">
                                </div>
                            </div>
                            <div class="row g-3 mb-3">
                                <div class="col">
                                    <label for="userAmIka" class="form-label">ΑΜ ΙΚΑ</label>
                                    <input type="text" class="form-control" id="userAmIka" v-model="userData.amIka"
                                        placeholder="Α.Μ. ΙΚΑ">
                                </div>
                                <div class="col">
                                    <label for="userAmka" class="form-label">ΑΜΚΑ</label>
                                    <input type="number" class="form-control" id="userAmka" v-model="userData.amka"
                                        placeholder="ΑΜΚΑ">
                                </div>
                                <div class="col">
                                    <label for="userAmMiscDepartment" class="form-label">ΑΜ ΑΛΛΟΥ ΑΣΦΑΛΙΣΤΙΚΟΥ
                                        ΤΑΜΕΙΟΥ</label>
                                    <input type="text" class="form-control" id="userAmMiscDepartment"
                                        v-model="userData.amMiscDepartment" placeholder="ΑΜ ΑΛΛΟΥ ΑΣΦΑΛΙΣΤΙΚΟΥ ΤΑΜΕΙΟΥ">
                                </div>
                                <div class="col">
                                    <label for="userTaxEmail" class="form-label">User Tax Email</label>
                                    <input type="text" class="form-control" id="userTaxEmail"
                                        v-model="userData.taxEmail" placeholder="User Tax Email">
                                </div>
                            </div>
                            <div class="row g-3 mb-3">
                                <div class="col-sm-6">
                                    <label for="totalDaysOff" class="form-label">Σύνολο αδειών τρέχοντος έτους</label>
                                    <input type="number" class="form-control" id="totalDaysOff" placeholder="Σύνολο αδειών"
                                        v-model="userData.total_days_off">
                                </div>
                                <div class="col-sm-6">
                                    <label for="userBirthday" class="form-label">Ημερ.Γεννήσεως</label>
                                    <input type="date" class="form-control" id="userBirthday"
                                        v-model="userData.birthday">
                                </div>
                                <div class="col">
                                    <label for="userBirthplace" class="form-label">Τόπος Γεννήσεως</label>
                                    <input type="text" class="form-control" id="userBirthplace"
                                        v-model="userData.birthplace" placeholder="Τόπος Γεννήσεως">
                                </div>
                                <div class="col">
                                    <label for="userNationality" class="form-label">Ιθαγένεια</label>
                                    <input type="text" class="form-control" id="userNationality"
                                        v-model="userData.nationality" placeholder="Ιθαγένεια">
                                </div>
                            </div>
                            <div class="row g-3 mb-3">
                                <div class="col-sm-6">
                                    <label for="userAddress" class="form-label">Διεύθ. κατοικίας</label>
                                    <input type="text" class="form-control" id="userAddress" v-model="userData.address"
                                        placeholder="Διεύθ. κατοικίας">
                                </div>
                                <div class="col">
                                    <label for="userArea" class="form-label">Περιοχή</label>
                                    <input type="text" class="form-control" id="userArea" v-model="userData.area"
                                        placeholder="Περιοχή">
                                </div>
                                <div class="col">
                                    <label for="userPostal" class="form-label">ΤΚ</label>
                                    <input type="text" class="form-control" id="userPostal" v-model="userData.postal"
                                        placeholder="ΤΚ">
                                </div>
                            </div>
                            <div class="row g-3 mb-3">
                                <div class="col-sm-6">
                                    <label for="userMunicipality" class="form-label">Δημοτικό Διαμέρισμα</label>
                                    <input type="text" class="form-control" id="userMunicipality"
                                        v-model="userData.municipality" placeholder="Δημοτικό Διαμέρισμα">
                                </div>
                                <div class="col">
                                    <label for="userTel" class="form-label">Τηλέφωνο</label>
                                    <input type="tel" class="form-control" v-model="userData.tel"
                                        placeholder="Τηλέφωνο">
                                </div>
                                <div class="col">
                                    <label for="userMaritalStatus" class="form-label">Οικογενειακή κατάσταση</label>
                                    <input type="text" class="form-control" id="userMaritalStatus"
                                        v-model="userData.maritalStatus" placeholder="Οικογενειακή κατάσταση">
                                </div>
                            </div>
                             <div class="row g-3 mb-3">
                                <div class="col-sm-6">
                                    <label for="drivingLicense" class="form-label">Αριθμός Άδειας Οδήγησης</label>
                                    <input type="text" class="form-control" id="drivingLicense"
                                        v-model="userData.drivingLicense" placeholder="Αριθμός Άδειας Οδήγησης">
                                    
                                </div>
                                <div class="col">
                                    <label for="yearOfFirstInsurance" class="form-label">Έτος Πρώτης Ασφάλισης</label>
                                    <input type="text" class="form-control" v-model="userData.yearOfFirstInsurance"
                                        placeholder="Έτος Πρώτης Ασφάλισης">
                                </div>
                                <div class="col">
                                    <label for="numberOfChildren" class="form-label">Αριθμός Προστατευόμενων Τέκνων</label>
                                    <input type="number" class="form-control" id="numberOfChildren" min="0"
                                        v-model="userData.numberOfChildren" placeholder="Αριθμός Προστατευόμενων Τέκνων">
                                </div>
                            </div>
                              <div class="row g-3 mb-3">
                                <div class="col-sm-3">
                                    <label for="numberOfChildren" class="form-label">Προϋπηρεσία Με Ένσημα Σύνολο</label>
                                    <input type="text" class="form-control" id="numberOfChildren"
                                        v-model="userData.insuranceContributionsTotal" placeholder="Προϋπηρεσία Με Ένσημα Σύνολο">
                                </div>
                                <div class="col-sm-3">
                                    <label for="yearOfFirstInsurance" class="form-label">Προϋπηρεσία Με Ένσημα Ειδικότητας</label>
                                    <input type="text" class="form-control" v-model="userData.insuranceContributionsSpecialty"
                                        placeholder="Προϋπηρεσία Με Ένσημα Ειδικότητας">
                                </div>
                               
                            </div>
                            
                        </div>
                    </div>
                    <div class="modal-footer">
<!--                         <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Κλείσιμο</button>
 -->                        <button type="button" class="btn btn-secondary" @click="submitForm">SAVE</button>
                    </div>
                </div>
            </div>
        </div>

</template>



<script>
import { ref, computed, onMounted, onUnmounted } from 'vue';
import { useFetchData } from '@/composables/useFetchData';
import { fetchAll, createOrUpdate, get, massArchiveUsers } from '@/services/employees';
import { useRoute, useRouter } from 'vue-router';
import { useToast } from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import { mapGetters } from 'vuex';


const defaultUserData = {
    id: null,
    email: '',
    username: '',
    password: '',
    passwordConfirm: '',
    hireDate: '',
    active: '1',
    isAccountant: false,
    name: '',
    surname: '',
    fatherFullName: '',
    motherFullName: '',
    spouseFullName: '',
    identityType: 'Αστυνομική Ταυτότητα',
    identityNum: '',
    identityCreationDate: '',
    identityCreationDepartment: '',
    afm: '',
    doy: '',
    amIka: '',
    amka: '',
    amMiscDepartment: '',
    total_days_off: 0,
    taxEmail: '',
    birthday: '',
    birthplace: '',
    nationality: '',
    address: '',
    area: '',
    profilePath: null,
    postal: '',
    municipality: '',
    tel: '',
    maritalStatus: '',
    numberOfChildren:'',
    drivingLicense: '',
    yearOfFirstInsurance: '',
    insuranceContributionsTotal:'',
    insuranceContributionsSpecialty:'',
    
};

export default {
    name: 'Users',
    data() {
        return {
            isGridView: false, // true for grid view, false for list view
        };
    },
    computed: {
        ...mapGetters({
            getUserPermission: 'getUserPermission',
      getSuperUserPermission: 'getSuperUserPermission',
      getUserPackets: 'getUserPackets'
        }),
        userPermissions() {
            return this.getUserPermission('Users');
        },
        canCreateUser() {
            return this.userPermissions?.create === 1;
        },
        canArchive() {
      return this.userPermissions?.archive === 1;
    },
    canUpdateUser() {
            return this.userPermissions?.create === 1;
        },
        canEditUser() {
            return this.userPermissions?.edit === 1;
        },
        canEditAllUsers() {
            return this.userPermissions?.editAll === 1;
        },
        superUser() {
            return this.getSuperUserPermission === 1;
        },
        getUser() {
            return this.$store.state.userInfo.id;
        },
          // Packet-based feature flags
      hasCRM() {
        return this.getUserPackets.includes('CRM');
      },
      hasHR() {
        return this.getUserPackets.includes('HR');
      },
      hasProjectManagement() {
        return this.getUserPackets.includes('PROJECT MANAGEMENT');
      },
      hasMarketingHub() {
        return this.getUserPackets.includes('MARKETING HUB');
      },
      // Add more like:
      hasMED() {
        return this.getUserPackets.includes('MED');
      },
      filteredPermissions() {
    const exclusions = [];

    if (!this.hasCRM) {
        exclusions.push('Clients', 'Suppliers', 'Services', 'Users', 'Service Categories', 'Contacts');
    }
    if (!this.hasHR) {
        exclusions.push('Days off', 'Days off reports', 'Holidays');

    }
    if (!this.hasProjectManagement) {
        exclusions.push('Dashboard', 'Projects', 'Tasks', 'Subtasks', 'Reporting', 'Hours');
    }
    if (!this.hasMarketingHub) {
        exclusions.push('Lists');
    }

    return this.userData.permissions.filter(permission => {
        return !exclusions.includes(permission.entity.title);
    });
}
    },
    setup() {
        const route = useRoute();
        const router = useRouter();
        const { data, paginationLinks, filters, updateFilters, fetchData, sortBy } = useFetchData(fetchAll, { page: route.query.page || 1, active: route.query.active || 1}, { page: 1, active: 1 });

        const userData = ref(defaultUserData);
        const selectedUserIds = ref([]);
        const isDropdownOpen = ref(false);

        const toggleUserSelection = (userId, event) => {
            if (event.target.checked) {
                selectedUserIds.value.push(userId);
            } else {
                selectedUserIds.value = selectedUserIds.value.filter(id => id !== userId);
            }
            console.log(selectedUserIds);
        };

        const toggleUsersSelection = (userId, event) => {
            if (!selectedUserIds.value.includes(userId)) {
                selectedUserIds.value.push(userId);
            } else {
                selectedUserIds.value = selectedUserIds.value.filter(id => id !== userId);
            }
        };

        const archiveUsers = async () => {
            if (!selectedUserIds.value.length) {
                useToast().error('Δεν έχετε επιλέξει χρήστες');
                return;
            }
            const response = await massArchiveUsers({ ids: selectedUserIds.value });
            if (response.data.success) {
                useToast().success('Employee(s) archived successfully');
                fetchData();
            } else {
                useToast().error(response.data.message);
            }
        };

        const editUser = async (id) => {
            const userInfo = await get({ "id": id });
            if (userInfo.data.success) {
                userData.value = userInfo.data.data.info;
                userData.value.permissions = userInfo.data.data.info.permissions;
            }
            $("#create-employee-form").modal('toggle');
        };

        const createUser = async () => {
            userData.value = defaultUserData;
            $("#create-employee-form").modal('toggle');
        };

        const submitForm = async () => {
    let payload = {};

    if (userData.value.sendEmail) {
        // Only send email, username, and sendEmail
        payload = {
            email: userData.value.email,
            username: userData.value.username,
            sendEmail: true
        };
    } else {
        // Send full data
        payload = { ...userData.value };
    }

    const response = await createOrUpdate(payload);

    if (response.data.success) {
        useToast().success(response.data.message);
        $("#create-employee-form").modal('toggle');
        fetchData();
    } else {
        useToast().error(response.data.message);
    }
};

        const updatePermission = (index, permissionType, event) => {
            userData.value.permissions[index][permissionType] = event.target.checked ? 1 : 0;
        };

        
      const massCheckUncheckRow = (event, permission) => {
    const isChecked = event.target.checked;
    const permissionKeys = ['view', 'viewAdmin', 'edit', 'editAll', 'create', 'accept', 'archive', 'editCreator'];

    permissionKeys.forEach((key) => {
        if (permission[key] !== 'disabled') {
            permission[key] = isChecked ? 1 : 0;
        }
    });
};



        const getPageFromUrl = (url) => {
            if (!url) return null;
            const urlObj = new URL(url, window.location.origin);
            return urlObj.searchParams.get('page');
        };

        const dropdownStyle = computed(() => ({
            top: isDropdownOpen.value ? '100%' : 'initial',
            right: isDropdownOpen.value ? '0' : 'initial'
        }));

        const toggleDropdown = () => {
            isDropdownOpen.value = !isDropdownOpen.value;
        };

        const closeDropdown = () => {
            isDropdownOpen.value = false;
        };

        const searchAction = () => {
            setTimeout(() => {
                router.push({path: '/employees', query: {...route.query, search: $("#main-search-input").val()}});
            }, 300);
        };

        onMounted(() => {
            $(document.body).on('keyup', "#main-search-input", searchAction).on('click', "#main-search-input", searchAction);
        });

        onUnmounted(() => {
            $(document.body).off('keyup', "#main-search-input", searchAction).off('click', "#main-search-input", searchAction);
        });


        return { data, paginationLinks, filters, updateFilters, fetchData, getPageFromUrl, userData, submitForm, editUser, createUser, selectedUserIds, toggleUserSelection, toggleUsersSelection, updatePermission, massCheckUncheckRow, archiveUsers, toggleDropdown, closeDropdown, isDropdownOpen, dropdownStyle, sortBy };
    },
    metaInfo: {
        title: 'Χρήστες',
        meta: [
            { name: 'description', content: 'MIS - Εργαζόμενοι' },
            { property: 'og:title', content: 'MIS - Εργαζόμενοι' },
            { property: 'og:description', content: 'This is the employees page.' }
        ]
    }
};
</script>

<style scoped>
.checkbox-wrapper {
  margin-right: 10px;
}

.user-info {
  flex-grow: 1;
}
.userInfoText {
  margin-top: 10px;
}

.card.selected-card {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
tr.selected, div.selected {
    background: #b1afaf;
}
.nav-tabs.prtab-set {
  background: #f9fafb;
  border: none;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  width: 200px;
}

.nav-tabs.prtab-set .nav-item {
  flex: 1;
}

.nav-tabs.prtab-set .nav-link {
  border: none;
  /* padding: 1rem 0; */
  font-weight: 600;
  color: #6b7280; /* Gray-600 */
  background-color: transparent;
  transition: all 0.3s ease-in-out;
  border-radius: 0;
  width: 100%;
  box-shadow: inset 1px 1px 10px 0px #e8e8e8;
}

.nav-tabs.prtab-set .nav-link:hover {
  background-color: #e5e7eb; /* Gray-200 */
  color: #111827; /* Gray-900 */
}

.nav-tabs.prtab-set .nav-link.active {
  background-color: #a0a0a0; /* Blue-500 */
  color: #ffffff;
  border-radius: 0;
  box-shadow: inset 0 -3px 0 #858585; /* Blue-600 underline effect */
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media screen and (max-width: 768px) {
    .nav-tabs.prtab-set{
        width: 100%;
        margin-bottom: 20px;
    }
    .newuserbtn{
        width: 100%;
        margin-right: 20px;
    }
    .gridmob{
        flex-direction: column;
        align-items: center;
        text-align: center;
        margin-bottom: 20px;
    }
    .checkbox-wrapper{
        margin-right: 0px;
    }
}
</style>
